// Delete Message Component
// Following existing patterns from ProfileSettings

import React, { useState, useCallback } from 'react';
import { DeleteMessageProps } from '../../../types/messaging';
import {
  DeleteContainer,
  DeleteHeader,
  DeleteContent,
  DeleteMessage as StyledDeleteMessage,
  DeleteActions,
  DeleteButton,
  CancelButton,
  WarningIcon
} from '../../../styles/Messaging/MessageActions.styles';

export const DeleteMessage: React.FC<DeleteMessageProps> = ({
  message,
  onDeleteMessage,
  onCancel,
  disabled = false,
  isAdmin = false
}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = useCallback(async () => {
    if (disabled || isDeleting) return;

    try {
      setIsDeleting(true);
      await onDeleteMessage(message.id, isAdmin);
    } catch (error) {
      console.error('Failed to delete message:', error);
      setIsDeleting(false);
    }
  }, [message.id, onDeleteMessage, isAdmin, disabled, isDeleting]);

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const getDeleteText = () => {
    if (isAdmin) {
      return "Are you sure you want to delete this message? This action cannot be undone and will remove the message for all participants.";
    }
    return "Are you sure you want to delete this message? This action cannot be undone.";
  };

  return (
    <DeleteContainer>
      <DeleteHeader>
        <WarningIcon>⚠️</WarningIcon>
        <span>Delete Message</span>
        <CancelButton onClick={onCancel}>✕</CancelButton>
      </DeleteHeader>
      
      <DeleteContent>
        <div style={{ marginBottom: '1rem' }}>
          {getDeleteText()}
        </div>
        
        <StyledDeleteMessage>
          <div style={{ fontSize: '0.875rem', color: '#6c757d', marginBottom: '0.25rem' }}>
            {message.senderName} • {formatTime(message.createdAt)}
          </div>
          <div style={{ fontSize: '0.9rem', fontStyle: 'italic' }}>
            "{message.content}"
          </div>
        </StyledDeleteMessage>
      </DeleteContent>
      
      <DeleteActions>
        <CancelButton onClick={onCancel} disabled={isDeleting}>
          Cancel
        </CancelButton>
        <DeleteButton
          onClick={handleDelete}
          disabled={disabled || isDeleting}
          $isDeleting={isDeleting}
        >
          {isDeleting ? 'Deleting...' : 'Delete Message'}
        </DeleteButton>
      </DeleteActions>
    </DeleteContainer>
  );
};
